import React from 'react';

export function Chart({ title, type = 'line', data = [] }) {
  // Safe defaults
  const points = data.length > 0 ? data : [30, 45, 35, 60, 40, 70, 65];
  const maxVal = Math.max(...points, 100);
  
  return (
    <div className="rounded-card border border-border bg-white p-6 font-body">
      <div className="flex justify-between items-center mb-6">
        <h4 className="text-small font-semibold text-text-primary uppercase tracking-wide">{title || 'Performance'}</h4>
        <span className="text-caption text-text-secondary">Últimos 7 dias</span>
      </div>
      
      <div className="h-48 w-full flex items-end justify-between relative pt-4">
        {/* Grid lines */}
        <div className="absolute inset-0 flex flex-col justify-between pointer-events-none opacity-40">
          <div className="border-b border-border w-full h-0"></div>
          <div className="border-b border-border w-full h-0"></div>
          <div className="border-b border-border w-full h-0"></div>
          <div className="border-b border-border w-full h-0"></div>
        </div>

        {type === 'bar' ? (
          <div className="w-full h-full flex items-end justify-around gap-2 z-10">
            {points.map((val, idx) => {
              const pct = (val / maxVal) * 100;
              return (
                <div key={idx} className="flex flex-col items-center flex-1 group">
                  <div 
                    style={{ height: `${pct}%` }} 
                    className="w-full max-w-[24px] bg-primary rounded-t-sm transition-all duration-300 group-hover:bg-secondary"
                  />
                  <span className="text-caption text-text-secondary mt-2">{['S', 'T', 'Q', 'Q', 'S', 'S', 'D'][idx]}</span>
                </div>
              );
            })}
          </div>
        ) : (
          <div className="w-full h-full relative z-10">
            <svg viewBox="0 0 300 120" className="w-full h-full overflow-visible">
              <defs>
                <linearGradient id="chartGrad" x1="0" y1="0" x2="0" y2="1">
                  <stop offset="0%" stopColor="#F2DB94" stopOpacity="0.4" />
                  <stop offset="100%" stopColor="#F2DB94" stopOpacity="0" />
                </linearGradient>
              </defs>
              
              {/* Line path */}
              {(() => {
                const step = 300 / (points.length - 1);
                const coords = points.map((p, i) => {
                  const x = i * step;
                  const y = 100 - (p / maxVal) * 80;
                  return { x, y };
                });
                
                const d = coords.map((c, i) => `${i === 0 ? 'M' : 'L'} ${c.x} ${c.y}`).join(' ');
                const areaD = `${d} L ${coords[coords.length - 1].x} 120 L 0 120 Z`;
                
                return (
                  <>
                    <path d={areaD} fill="url(#chartGrad)" />
                    <path d={d} fill="none" stroke="#351514" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" />
                    {coords.map((c, i) => (
                      <circle 
                        key={i} 
                        cx={c.x} 
                        cy={c.y} 
                        r="3.5" 
                        className="fill-white stroke-primary stroke-2 hover:r-5 transition-all cursor-pointer" 
                      />
                    ))}
                  </>
                );
              })()}
            </svg>
            <div className="flex justify-between text-caption text-text-secondary mt-2 px-1">
              <span>Seg</span>
              <span>Ter</span>
              <span>Qua</span>
              <span>Qui</span>
              <span>Sex</span>
              <span>Sáb</span>
              <span>Dom</span>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}
